angular
	.module 'App.Directive'
	.directive 'benefitProducts', ->
		templateUrl: '@directive/benefit-products/benefit-products.view.html'
		restrict: 'E'
		scope:
			benefitProducts: '='
			productCategories: '='
			productFilters: '='
			minUnionCategories: '=?'
			unionSearch: '=?'
			showPriceField: '=?'
			useInvertedTabs: '<?'
		controller: 'BenefitProductsController'
		controllerAs: 'benefitProducts'
		bindToController: true

class BenefitProductsController extends AbstractController
	@register angular.module 'App.Directive'
	@inject '$q',
		'PromotionCampaignService'
		'ProductRepository'
		'ProductFilterRepository'
		'PROMOTION_CONSTANTS'
		'DEFAULT_PRODUCT_DATA_LABEL'
		'parseBool'
		'ConfigurationService'

	initialize: ->
		@useInvertedTabs ?= false

		@categories = _.sortBy(angular.copy(@productCategories), 'path')
		@subcategories = _.groupBy(@categories, 'parent_id')
		delete @subcategories[null]

		@constants = @PROMOTION_CONSTANTS
		@selectedCategory = null
		@selectedCategories = []
		@selectedProductFilters = []
		@productsSearch = []
		@productFilter = null
		@productFilterValue = null
		@initialBenefitProducts = angular.copy @benefitProducts
		@benefitProducts = []
		@benefitCategories = []
		@unionSearch ?= false
		@showPriceField ?= false
		@minUnionCategories ?= 2
		@unionProducts = {}
		@unionCategories = []
		@categorized = true
		@noCategory =
			id: '-1'
			name: @constants.noCategory
			path: @constants.noCategory

		@tabs = [
			{
				active: true
				title: 'wbo.promotion.benefit.products.add_from_categories'
				selector: "#tab-add-from-categories-#{@controllerId}"
			}
			{
				title: 'wbo.promotion.benefit.products.add_from_filters'
				selector: "#tab-add-from-filters-#{@controllerId}"
				disabled: @ConfigurationService.isDisabled 'Shared.Setting.ProductFilter.Enabled'
			}
			{
				title: 'wbo.promotion.benefit.products.add_from_search'
				selector: "#tab-add-from-search-#{@controllerId}"
			}
		]

		@addBenefitProducts @initialBenefitProducts

	searchProducts: (searchTerm) ->
		@PromotionCampaignService
			.queryBenefitProducts {name: searchTerm}
			.then (response) =>
				@productsSearch = response

	addSearchProduct: (product) ->
		@addBenefitProduct product

		_.without @productsSearch, product

	addBenefitProductsFromCategory: (selectedCategoryId) ->
		query = @ProductRepository.createQuery()
		query.with('product_categories', 'product_variants', 'product_data')

		if @unionSearch
			if @selectedCategories.length < @minUnionCategories
				return

			categoryIds = @resolveBenefitProductCategoryIds(_.pluck(@selectedCategories, 'id'))
		else
			categoryIds = @resolveBenefitProductCategoryIds([selectedCategoryId])

		# Do not use IN condition until WM-843 is resolved
		# Using IN condition will not return _all_ product categories, but only one from IN condition
		criteria = null

		for categoryId in categoryIds
			if not criteria?
				criteria = query.criteria('product_categories>id', '=', categoryId)
			else
				criteria.or('product_categories>id', '=', categoryId)

		@ProductRepository
			.findByQuery query, false, true
			.then (response) =>
				if @unionSearch
					# Remove previously added union categories, leaving only manually added categories
					if not _.isEmpty @unionCategories
						@benefitCategories = _.difference @benefitCategories, @unionCategories

					@unionCategories = angular.copy @selectedCategories
					@benefitCategories = @mergeCategories(@benefitCategories, @unionCategories)

					# Remove previously added union products, leaving only manually added products
					if not _.isEmpty @unionProducts
						@benefitProducts = _.difference @benefitProducts, _.values(@unionProducts)
						@unionProducts = {}

					for product in response.data
						missingCategories = _.difference(
							categoryIds,
							_.pluck(product.product_categories, 'id')
						)

						if missingCategories.length == 0
							@unionProducts[product.id] = product
							@addBenefitProduct product
				else
					for product in response.data
						@addBenefitProduct(product)

	updateBenefitProductsFromProductFilters: ->
		if _.isEmpty @selectedProductFilters
			return

		query = @ProductRepository.createQuery()
		query.with 'product_filters', 'product_variants', 'product_data', 'product_categories'

		for productFilter in @selectedProductFilters
			criteria = query.criteria 'product_filters>product_filter_id', '=', productFilter.id
			criteria.and 'product_filters>value', '=', productFilter.value

		@ProductRepository
			.findByQuery query, false, true
			.then (response) =>
				for product in response.data
					@addBenefitProduct product

	addProductFilter: ->
		existingFilter = _.find(
			@selectedProductFilters,
			(selectedProductFilter) => selectedProductFilter.name == @getProductFilterName()
		)

		if existingFilter?
			@productFilter = null
			@productFilterValue = null

			return

		@selectedProductFilters.push({
			name: @getProductFilterName(),
			id: @productFilter.id,
			value: @productFilterValue,
		})

		@productFilter = null
		@productFilterValue = null

	getProductFilterName: ->
		return "#{@productFilter.name}:#{@productFilterValue}"

	canAddProductFilter: ->
		return !_.isEmpty(@productFilter) && !_.isEmpty(@productFilterValue)

	addProductPath: (product) ->
		product.product_categories ?= []

		return if _.isEmpty product.product_categories

		for productCategory in product.product_categories
			category = _.find(@categories, {id: productCategory.id})

			productCategory.path = if category? then category.path else productCategory.name

	addBenefitProducts: (products) ->
		for product in products
			@addBenefitProduct(
				if product.products? then product.products else product,
				if product.products? then product.product_variants else null,
				product.retail_price
			)

	addBenefitProduct: (product, benefitVariants, retailPrice = null) ->
		@addProductPath(product)

		product.retail_price = retailPrice || @getRetailPrice(product)

		product.selected = true

		benefitVariantsMap = _.indexBy(benefitVariants, (item) => item.product_variant_id || item)

		for variant in product.product_variants
			if !_.isEmpty(benefitVariantsMap)
				variant.selected = !_.isEmpty(benefitVariantsMap[variant.id])
				variant.retail_price = benefitVariantsMap[variant.id]?.retail_price || @getRetailPrice(variant)
			else
				variant.selected = true
				variant.retail_price = @getRetailPrice(variant)

		###
		 Push only if the product is not already in the products array
		###
		currentProductIds = _.pluck @benefitProducts, 'id'

		if currentProductIds.indexOf(product.id) == -1
			@benefitProducts.push product

		###
		 Product has no category so add it to Uncategorized category
		###
		if product.product_categories.length == 0 and not _.find(@benefitCategories, {id: @noCategory.id})?
			@benefitCategories.push @noCategory
		else
			# Add the product category name if it's not already added
			for productCategory in product.product_categories
				if not _.find(@benefitCategories, {id: productCategory.id})?
					@benefitCategories.push productCategory

	hasProducts: (category) ->
		for product in @benefitProducts
			if category.id == @noCategory.id and product.product_categories.length == 0
				return true
			else
					for productCategory in product.product_categories
						if productCategory.id == category.id
							return true

		return false

	removeCategory: (category) ->
		categories = []

		@benefitProducts = @benefitProducts.filter (product) =>
			if category.id == @noCategory.id and product.product_categories.length == 0
				return false

			inCategory = angular.isDefined(_.findWhere(product.product_categories, {id: category.id}))

			if not inCategory
				if product.product_categories.length == 0
					categories.push(@noCategory) if not _.find(categories, {id: @noCategory.id})?
				else
					categories = @mergeCategories(categories, product.product_categories)

				return true
			else
				return false

		@benefitCategories = categories

	findCategories: (query) ->
		filteredCategories = angular.copy @categories

		if not _.isEmpty query
			filteredCategories = _.filter filteredCategories, (category) -> category.name.toLowerCase().indexOf(query) != -1

		return @$q.when filteredCategories

	getRetailPrice: (item) ->
		return null if _.isEmpty item.product_data

		defaultData = item.product_data.find((data) => data.entity_type == @DEFAULT_PRODUCT_DATA_LABEL)

		return defaultData.retail_price if defaultData? and defaultData.retail_price != '0'
		return item.product_data[0].retail_price if item.product_data[0]? and item.product_data[0].retail_price != '0'
		return null

	mergeCategories: (pool, categories) ->
		return _.chain(pool)
			.union(categories)
			.uniq(false, (category) => category.id)
			.value()

	resolveBenefitProductCategoryIds: (parentCategoryIds) ->
		categoryIds = parentCategoryIds
		categoryIdsToSkip = new Set(categoryIds)

		consideredCategoryIdIndex = 0

		while consideredCategoryIdIndex < categoryIds.length
			categoryId = categoryIds[consideredCategoryIdIndex]
			consideredCategoryIdIndex++
			subcategoryIds = _.pluck(@subcategories[categoryId] ? [], 'id')

			for subcategoryId in subcategoryIds
				if categoryIdsToSkip.has(subcategoryId)
					continue

				categoryIds.push(subcategoryId)
				categoryIdsToSkip.add(subcategoryId)

		return categoryIds
